import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Plug, UserCog, LifeBuoy } from 'lucide-react';

const ITEMS = [
  {
    icon: <Lock className="h-5 w-5" />,
    title: 'Keamanan akun & token',
    points: [
      'Password disimpan sebagai hash bcrypt, bukan teks biasa',
      'Token channel WhatsApp/Instagram dienkripsi di database',
      'Seluruh trafik lewat HTTPS',
    ],
  },
  {
    icon: <Plug className="h-5 w-5" />,
    title: 'Integrasi resmi',
    points: [
      'WhatsApp Cloud API, Instagram & Messenger lewat API resmi Meta',
      'Nomor WhatsApp dan akun sosial tetap milik Anda',
      'Koneksi bisa dicabut kapan saja dari halaman Channel',
    ],
  },
  {
    icon: <UserCog className="h-5 w-5" />,
    title: 'Data & privasi',
    points: [
      'Data tiap akun terpisah — hanya Anda dan tim yang Anda undang',
      'Percakapan dipakai untuk menjawab pelanggan Anda, bukan dijual',
      'Permintaan ekspor atau hapus data dilayani lewat email support',
    ],
  },
  {
    icon: <LifeBuoy className="h-5 w-5" />,
    title: 'Onboarding & dukungan',
    points: [
      'Setup mandiri: hubungkan channel, isi katalog & FAQ, AI siap jalan',
      'Panduan di dalam aplikasi untuk tiap langkah',
      'Dukungan lewat email, dibalas pada hari kerja',
    ],
  },
];

export const TrustSection = ({ className = '' }) => (
  <div className={className} data-testid="trust-section">
    <div className="grid gap-4 sm:grid-cols-2 lg:gap-5">
      {ITEMS.map((item, index) => (
        <motion.div
          key={item.title}
          data-testid={`trust-card-${index + 1}`}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.45, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
          className="group rounded-2xl border border-slate-200 bg-white p-5 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:border-indigo-400 hover:shadow-[0_24px_48px_-24px_rgba(79,70,229,0.45)] dark:border-zinc-800 dark:bg-zinc-900 dark:hover:border-indigo-500/70 sm:p-6"
        >
          <div className="mb-4 grid h-10 w-10 place-items-center rounded-xl bg-indigo-50 text-indigo-600 transition-colors group-hover:bg-indigo-100 dark:bg-indigo-500/10 dark:text-indigo-300 dark:group-hover:bg-indigo-500/20">
            {item.icon}
          </div>
          <h3 className="mb-3 text-base font-semibold text-slate-900 dark:text-white sm:text-lg">
            {item.title}
          </h3>
          <ul className="space-y-2">
            {item.points.map((point) => (
              <li key={point} className="flex gap-2.5 text-sm leading-relaxed text-slate-600 dark:text-zinc-400">
                <span aria-hidden="true" className="mt-[7px] h-1 w-1 flex-shrink-0 rounded-full bg-indigo-500" />
                <span className="min-w-0">{point}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      ))}
    </div>
  </div>
);

export default TrustSection;
